/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 * 金额转换
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: "E" },
    { value: 1e15, symbol: "P" },
    { value: 1e12, symbol: "T" },
    { value: 1e9, symbol: "G" },
    { value: 1e6, symbol: "M" },
    { value: 1e3, symbol: "k" }
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[i].symbol
      );
    }
  }
  return num.toString();
}

/**
 *
 * @param {num } num // 千分位 保留两位小数
 */
export function price(a) {
  if (a == null || a == undefined) return "";
  var num = Number(a);
  if (!num) {
    // 等于0
    return num + ".00";
  } else {
    // 不等于0
    num = Math.round(num * 100) / 10000;
    num = num.toFixed(2);
    num += ""; // 转成字符串
    var reg =
      num.indexOf(".") > -1
        ? /(\d{1,3})(?=(?:\d{3})+\.)/g
        : /(\d{1,3})(?=(?:\d{3})+$)/g; // 千分符的正则
    return num.replace(reg, "$1,"); // 千分位格式化
  }
}

// 阿拉伯数字转换成大写汉字
// 汉字的数字
export function numberParseChina(money) {
  var cnNums = new Array(
    "零",
    "壹",
    "贰",
    "叁",
    "肆",
    "伍",
    "陆",
    "柒",
    "捌",
    "玖"
  );
  // 基本单位
  var cnIntRadice = new Array("", "拾", "佰", "仟");
  // 对应整数部分扩展单位
  var cnIntUnits = new Array("", "万", "亿", "兆");
  // 对应小数部分单位
  var cnDecUnits = new Array("角", "分", "毫", "厘");
  // 整数金额时后面跟的字符
  var cnInteger = "整";
  // 整型完以后的单位
  var cnIntLast = "圆";
  // 最大处理的数字
  var maxNum = 999999999999999.9999;
  // 金额整数部分
  var integerNum;
  // 金额小数部分
  var decimalNum;
  // 输出的中文金额字符串
  var chineseStr = "";
  // 分离金额后用的数组，预定义
  var parts;
  if (money == "") {
    return "";
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    // 超出最大处理数字
    return "";
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  // 转换为字符串
  money = money.toString();
  if (money.indexOf(".") == -1) {
    integerNum = money;
    decimalNum = "";
  } else {
    parts = money.split(".");
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  // 获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == "0") {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        // 归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m === 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  // 小数部分
  if (decimalNum != "") {
    var decLen = decimalNum.length;
    // eslint-disable-next-line no-redeclare
    for (var i = 0; i < decLen; i++) {
      // eslint-disable-next-line no-redeclare
      var n = decimalNum.substr(i, 1);
      if (n != "0") {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == "") {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == "") {
    chineseStr += cnInteger;
  }
  return chineseStr;
}



// 日期格式化
export function parseTime (time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/')
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}


//利率显示格式化
export function formatRate(value)
{
  value=value/100000000
  // 非数值或字符串直接返回原值
  if (typeof (value) !== 'number' && typeof (value) !== 'string')
    return value;
  // 数值转字符串
  if (typeof (value) === 'number')
    value = value.toFixed(8);
  // 查找小数点
  let dotPos = value.indexOf('.');
  if (dotPos >= 0)
  {
    // 去除末尾的0
    let zeroPos = -1;
    for (let i = value.length - 1; i >= 0; --i)
    {
      if (value.charAt(i) !== '0')
        break;
      zeroPos = i;
    }
    // 去除最后的小数点
    if (zeroPos == dotPos + 1)
      zeroPos = dotPos;
    // 截取
    if (zeroPos >= 0)
      value = value.substr(0, zeroPos)
  }
  return value;
}


// WEBPACK FOOTER //
// ./src/utils/filters/index.js